import { Switch as HeadlessSwitch } from '@headlessui/react';
import { ReactElement } from 'react';

interface Props {
  label?: string;
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  disabled?: boolean;
  size?: keyof typeof sizeClassMap;
}

const sizeClassMap = {
  sm: 'h-5 w-[34px]',
  m: 'w-[50px] h-7',
  lg: 'w-[60px] h-9',
};

const spanClassMap = {
  sm: 'size-4 group-data-[checked]:translate-x-4',
  m: 'size-6 group-data-[checked]:translate-x-6',
  lg: 'size-7 group-data-[checked]:translate-x-7',
};

export const Switch = ({
  enabled,
  setEnabled,
  label,
  disabled,
  size = 'm',
}: Props): ReactElement => (
  <div className="flex items-center space-x-2">
    <HeadlessSwitch
      checked={enabled}
      onChange={setEnabled}
      disabled={!!disabled}
      className={`group inline-flex ${sizeClassMap[size]} items-center rounded-full bg-grey-500 transition active:shadow-focused-dark hover:bg-grey-400 data-checked:bg-primary-400 data-checked:hover:bg-primary-300 disabled:bg-background-disabled  data-checked:disabled:bg-primary-t-400`}
    >
      <span
        className={`${spanClassMap[size]} translate-x-0.5 rounded-full bg-white transition`}
      />
    </HeadlessSwitch>
    {!!label && <span className="text-[0.9375rem] text-black">{label}</span>}
  </div>
);
